<style lang="less">
  @import "../assets/common.less";


  .layout {
    padding-top: 60px;
    height: 100%;
    background: #f5f7f9;

    .layout-breadcrumb {
      padding: 10px 15px 0;
    }
  }
</style>
<template>
  <div class="layout">
    <CommonHeader></CommonHeader>
    <CommonMain></CommonMain>
    <!-- <CommonFooter></CommonFooter> -->
  </div>
</template>
<script>
  import CommonHeader from './layout/CommonHeader.vue'
  import CommonMain from './layout/CommonMain.vue'
  import CommonFooter from './layout/CommonFooter.vue'
  export default {
    components: {
      CommonHeader,
      CommonMain,
      CommonFooter
    },
    data () {
      return {}
    },
    methods: {},
    created () {
    }
  }
</script>



// WEBPACK FOOTER //
// Home.vue?6f3f1053